import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-150fc38d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "com-upload",
  style: {"position":"relative"}
}
const _hoisted_2 = {
  class: "search-bt",
  style: {"position":"fixed","right":"20px","top":"80px","z-index":"999"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "canvas-box",
  id: "canvasBox"
}, [
  /*#__PURE__*/_createElementVNode("canvas", {
    id: "myCanvas",
    class: "canvas-dom",
    style: {"boder":"1px solid red"}
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_search = _resolveComponent("van-search")!
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_search, {
      modelValue: _ctx.spaceName,
      "onUpdate:modelValue": [
        _cache[0] || (_cache[0] = ($event: any) => ((_ctx.spaceName) = $event)),
        _ctx.searchSpace
      ],
      class: "space-search",
      placeholder: "请输入搜索关键词"
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.zommAdd && _ctx.zommAdd(...args))),
        style: {"display":"inline-block","font-size":"30px"}
      }, [
        _createVNode(_component_van_icon, {
          name: "add-o",
          color: "#1989fa"
        })
      ]),
      _createElementVNode("div", {
        onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.zommDel && _ctx.zommDel(...args))),
        style: {"display":"inline-block","font-size":"30px"}
      }, [
        _createVNode(_component_van_icon, {
          name: "minus",
          color: "#1989fa"
        })
      ])
    ]),
    _hoisted_3
  ]))
}